export function normalizeMerchantList(merchantList) {
    return merchantList.map((merchant) => {
        return {
            merchantId: merchant.merchant_id,
            merchantName: merchant.name,
        };
    });
}

export function normalizeMerchantInfo(merchant) {
    return {
        merchantId: merchant.merchant_id,
        merchantName: merchant.name,
        denominations: merchant.denominations,
    };
}

export function normalizeDenominations(denominations) {
    return denominations.map((denomination) => {
        return {
            denominationId: denomination.denomination_id,
            denominationName: denomination.name,
            denominationValue: denomination.price,
        };
    });
}
